import React, { FC, useCallback } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import {
  IField_Storage_File,
} from '@kaidam/fc-shared/src/types/storage'
import prettyBytes from 'pretty-bytes'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import {
  isImage,
} from '@kaidam/fc-shared/src/utils/file'

import ClickLink from '../widgets/ClickLink'

import FileUploader from './FileUploader'

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: theme.spacing(1),
  },
  uploader: {

  },
  filelist: {
    marginTop: theme.spacing(2),
  },
  file: {

  },
  fileSize: {

  },
  thumbnail: {
    height: '100px',
    minHeight: '100px',
    maxHeight: '100px',
  },
  thumbnailImage: {
    border: '1px solid #000',
    height: '100px',
    minHeight: '100px',
    maxHeight: '100px',
  }
}))

const FileList: FC<React.PropsWithChildren<{
  token: string,
  path: string,
  readonly?: boolean,
  data: IField_Storage_File[],
  onChange: (files: IField_Storage_File[]) => void,
}>> = ({
  token,
  path,
  readonly = false,
  data,
  onChange,
}) => {

  const classes = useStyles()

  const onUpload = useCallback((files: any) => {
    onChange(data.concat(files))
  }, [
    data,
    onChange,
  ])
  
  return (
    <div className={ classes.container }>
      {
        !readonly && (
          <div className={ classes.uploader }>
            <FileUploader
              token={ token }
              path={ path }
              onUpload={ onUpload }
            />
          </div>
        )
      }
      <div className={ classes.filelist }>
        <Grid container spacing={ 1 }>
          {
            data.map((file, i) => {
              const url = `/api/v1/ft_booking_public/file?access_token=${token}&path=${file.pointer.path}`
              return (
                <React.Fragment key={ i }>
                  <Grid item xs={ 12 } sm={ 6 }>
                    <div className={ classes.file }>
                      <FormHelperText>
                        <a href={ url } target="_blank" rel="noopener noreferrer">
                          {
                            file.pointer.path
                          }
                        </a>
                      </FormHelperText>
                      <FormHelperText>
                        { prettyBytes(parseInt(file.meta.size ? file.meta.size : '0')) }  
                      </FormHelperText>
                      {
                        !readonly && (
                          <FormHelperText>
                            <ClickLink
                              onClick={ () => {
                                onChange(data.filter((file, j) => i !== j))
                              } }
                            >
                              remove
                            </ClickLink>
                          </FormHelperText>
                        )
                      }
                    </div>
                  </Grid>
                  <Grid item xs={ 12 } sm={ 6 }>
                    <div className={ classes.thumbnail }>
                      {
                        isImage(file) && (
                          <img src={ url } className={ classes.thumbnailImage } />
                        )
                      }
                    </div>
                  </Grid>
                </React.Fragment> 
              )
            })
          }
        </Grid>
      </div>
    </div>
  )
}

export default FileList